var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3874 3.99497C14.7561 4.85605 14.8464 5.81089 14.6455 6.72582C14.4447 7.64075 13.9627 8.46997 13.2671 9.09737C12.5716 9.72477 11.6972 10.119 10.7665 10.2247C9.83577 10.3305 8.89526 10.1426 8.07664 9.68726L4.13421 14.2551C3.81736 14.572 3.38762 14.75 2.93953 14.75C2.49144 14.75 2.0617 14.572 1.74485 14.2551C1.428 13.9383 1.25 13.5086 1.25 13.0605C1.25 12.6124 1.428 12.1826 1.74485 11.8658L6.31274 7.92336C5.85742 7.10474 5.66949 6.16423 5.77527 5.2335C5.88104 4.30277 6.27523 3.42842 6.90263 2.73285C7.53003 2.03729 8.35925 1.55533 9.27418 1.35446C10.1891 1.1536 11.144 1.24387 12.005 1.61265L9.05347 4.55718L9.45404 6.54596L11.4428 6.94653L14.3874 3.99497Z",
    stroke: "#EAECF0",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTools);
export default __webpack_public_path__ + "static/media/Tools.f9c7c13e6caee77540b746a4186a1ef1.svg";
export { ForwardRef as ReactComponent };